import {checkIsWXWork} from "./utils";
// 缓存相关
export const StorageKey = {
  userId: 'userId',
  username: 'username',
  userProfile: 'userProfile',
  unitMinutes: 'unitMinutes',  // 会议预约单位时间
  token: 'token',
  tokenExpiresAt: 'tokenExpiresAt',
  mtBackRoute: 'mtBackRoute',
  rmBackRoute: 'rmBackRoute',
  sysConfig: 'sysConfig',
  sysView: 'sysView',
  roomTitle: 'roomTitle',
  meetingStatus: 'meetingStatus',
  mobJsBridge: 'mobJsBridge',
  pathRecord: 'pathRecord',
  queryRecord: 'queryRecord',
  redirectRecord: 'redirectRecord'
};

export function setStorage(key, content) {
  // 考虑 null 的情况
  const _content = content && (typeof content !== 'string') ? JSON.stringify(content) : (content || "");
  localStorage.setItem(key, _content)
}

export function getStorage(key, needParse = false) {
  if (needParse) return JSON.parse(localStorage.getItem(key) || '{}');

  return localStorage.getItem(key)
}

export function clearStorage(key) {
  if (key) {
    localStorage.removeItem(key);
    return
  }
  localStorage.clear();
}

export function checkTokenNotExpired() {
  // // 企业微信不过期 Livia 2021-03-02
  // if (checkIsWXWork()) return true;

  const tokenExpiresAt = getStorage(StorageKey.tokenExpiresAt);
  if (!tokenExpiresAt) return false;
  // console.log({tokenExpiresAt});

  const tokenDiff = moment(new Date()).diff(moment(Number(tokenExpiresAt)), 's');
  // console.log({tokenDiff});

  return tokenDiff < 1
}
